/**
 * i18n — Sistema de traducciones ES/EN con persistencia en localStorage.
 */

let translations: Record<string, string> = {};
let currentLang = "es";

const LANG_KEY = "wa_lang";

export async function loadLanguage(lang: string): Promise<void> {
  currentLang = lang;
  localStorage.setItem(LANG_KEY, lang);
  try {
    const res = await fetch(`/locales/${lang}.json?v=${Date.now()}`);
    translations = await res.json();
  } catch {
    console.warn(
      `i18n: could not load locale "${lang}", falling back to empty`,
    );
    translations = {};
  }
  // Actualizar todos los elementos con data-i18n en el DOM
  applyTranslations();
}

export function getLanguage(): string {
  return localStorage.getItem(LANG_KEY) || "es";
}

/** Traduce una clave. Si no encuentra la clave, retorna la clave misma. */
export function t(key: string, vars?: Record<string, string>): string {
  let text = translations[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      text = text.replace(`{{${k}}}`, v);
    }
  }
  return text;
}

/** Aplica todas las traducciones a elemetos con [data-i18n] en el DOM */
export function applyTranslations(): void {
  document.querySelectorAll<HTMLElement>("[data-i18n]").forEach((el) => {
    const key = el.getAttribute("data-i18n")!;
    el.textContent = t(key);
  });
  document
    .querySelectorAll<HTMLElement>("[data-i18n-placeholder]")
    .forEach((el) => {
      const key = el.getAttribute("data-i18n-placeholder")!;
      (el as HTMLInputElement).placeholder = t(key);
    });
  document.querySelectorAll<HTMLElement>("[data-i18n-title]").forEach((el) => {
    const key = el.getAttribute("data-i18n-title")!;
    el.title = t(key);
  });
}
